export interface Project {
  id: string;
  title: string;
  category: 'game' | 'ai' | 'cyber' | 'web' | 'fullstack' | 'automation' | '3d';
  categoryLabel: string;
  image: string;
  gifUrl?: string;
  description: string;
  technologies: string[];
  githubUrl: string;
  demoUrl?: string;
  stlUrl?: string | string[];
}

const projects: Project[] = [
  {
    id: 'talon',
    title: 'Talon Monodrone',
    category: '3d',
    categoryLabel: '3D Model',
    image: '/assets/images/models_images/Talon.jpeg',
    stlUrl: '/assets/models/Talon.stl',
    description: 'A single motor ducted monodrone with thrust vectoring. Eight stator vanes reduce motor torque. Four servo controlled vanes handle pitch, roll, and yaw. The battery sits below the duct to keep the weight centered.',
    technologies: ['Fusion 360', '3D Printing', 'Mechanical Design', 'Aerodynamics', 'Robotics'],
    githubUrl: 'https://github.com/YegorCherov/Talon'
  },
  {
    id: 'apexPayloadDropper',
    title: 'Apex FPV Payload Dropper',
    category: '3d',
    categoryLabel: '3D Model',
    image: '/assets/images/models_images/Apex.jpeg',
    stlUrl: '/assets/models/Apex.stl',
    description: 'A mechanical dropper for FPV drones. Four Geneva mechanisms sit on one shaft and release four separate items from a single servo movement. The slots are open enough to fit different shapes.',
    technologies: ['Fusion 360', '3D Printing', 'Mechanical Design', 'Engineering'],
    githubUrl: 'https://github.com/YegorCherov/Apex'
  },
  {
    id: 'peltierSleepingMat',
    title: 'Peltier Water Cooled Sleeping Mat',
    category: 'automation',
    categoryLabel: 'Automation',
    image: '/assets/images/Peltier.jpeg',
    description: 'A water cooled sleeping mat built around a Peltier module, copper block, brushless pump, and custom printed case. An ESP32 runs the temperature and fan controls through a small web interface. The single Peltier was not enough for body heat, but the system worked as intended.',
    technologies: ['ESP32', 'C++', 'Electronics', '3D Printing', 'Web UI'],
    githubUrl: 'https://github.com/YegorCherov/PBWCM'
  },
  {
    id: '3dpcbuilder',
    title: '3DPCBuilder',
    category: 'web',
    categoryLabel: 'Web Development',
    image: '/assets/images/3DPCBuilder.png',
    description: 'A site for planning a 3D PC build. Pick components, see the result, and check whether the parts work together.',
    technologies: ['React', 'Node.js', 'Three.js', 'WebGL'],
    githubUrl: 'https://github.com/YegorCherov',
    demoUrl: 'https://www.3dpcbuilder.com/'
  },
  {
    id: 'empire',
    title: 'EmpireToEnd',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/images/EmpireToEnd.png',
    description: 'A 2D pixel art strategy game about rival kingdoms. I worked on unit control, resource gathering, and the systems behind the game.',
    technologies: ['Unity', 'C#', 'Game Development', 'Pixel Art'],
    githubUrl: 'https://github.com/YegorCherov/EmpireToEnd'
  },
  {
    id: 'mapgen',
    title: 'Map Generator',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/gifs/Generation.mp4',
    description: 'A Unity terrain generator written in C sharp. It uses noise and chunk loading to create large maps without rendering everything at once.',
    technologies: ['Unity', 'C#', 'Procedural Generation', 'Perlin Noise'],
    githubUrl: 'https://github.com/YegorCherov/MapGenerator'
  },
  {
    id: 'watermark',
    title: 'WaterMark Detector',
    category: 'ai',
    categoryLabel: 'AI/ML',
    image: '/assets/gifs/Water-Gif.mp4',
    description: 'A computer vision project that detects watermarks. I trained the model on more than ten thousand images from several datasets.',
    technologies: ['Python', 'OpenCV', 'Computer Vision', 'Machine Learning'],
    githubUrl: 'https://github.com/YegorCherov/WatermarkDetector'
  },
  {
    id: 'multislicer',
    title: 'MultiSpriteSheetSlicer',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/images/SlicerToolsImage.png',
    description: 'A Unity editor tool for cutting sprite sheets into individual sprites. It includes options for the layout and output.',
    technologies: ['Unity', 'C#', 'Editor', 'Tool'],
    githubUrl: 'https://github.com/YegorCherov/MultiSpriteSheetSlicer'
  },
  {
    id: 'docscanner',
    title: 'Document Scanner',
    category: 'ai',
    categoryLabel: 'Computer Vision',
    image: '/assets/images/docscanner.png',
    description: 'A document scanner that finds the edges of a page and produces a cleaner scan.',
    technologies: ['Python', 'OpenCV', 'Scikit', 'Computer Vision'],
    githubUrl: 'https://github.com/YegorCherov/document-scanner'
  },
  {
    id: 'faceTracker',
    title: 'Face Tracker',
    category: 'ai',
    categoryLabel: 'Computer Vision',
    image: '/assets/gifs/FaceTrackerExampleCropped.mp4',
    description: 'A real time face tracker built with computer vision. It detects a face and follows its main features.',
    technologies: ['Python', 'OpenCV', 'Computer Vision', 'Machine Learning'],
    githubUrl: 'https://github.com/YegorCherov'
  },
  {
    id: 'rts',
    title: 'RTS Mechanics',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/gifs/RTSMechanics.mp4',
    description: 'A set of controls and game systems for real time strategy games.',
    technologies: ['Unity', 'C#', 'Game Development'],
    githubUrl: 'https://github.com/YegorCherov/EmpireToEnd'
  },
  {
    id: 'units',
    title: 'Basic Units',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/gifs/Hwacha.mp4',
    description: 'Several playable units including a catapult, hwacha, knight, archer, and builder. Each has its own movement and attack behavior.',
    technologies: ['Unity', 'C#', 'Game Development'],
    githubUrl: 'https://github.com/YegorCherov/EmpireToEnd'
  },
  {
    id: 'parallax',
    title: 'Infinite Parallax Background',
    category: 'game',
    categoryLabel: 'Game Development',
    image: '/assets/gifs/ParallaxBackground.mp4',
    description: 'A Unity script that moves three background layers at different speeds to create an endless parallax effect.',
    technologies: ['Unity', 'C#', 'Game Development'],
    githubUrl: 'https://github.com/YegorCherov/EmpireToEnd'
  },
  {
    id: 'fpvQuadDroneRetractableLegs',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'FPV quad drone retractable legs',
    image: '/assets/images/models_images/FPV Leg.png',
    stlUrl: ['/assets/models/FPV Leg Holder.stl', '/assets/models/FPV Leg.stl'],
    description: 'Retractable landing gear for an FPV quadcopter. It folds away for transport and gives the frame a wider base on the ground.',
    technologies: ['Fusion 360', '3D Printing', 'Mechanical Design'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'washingMachineDoorCloser',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Washing machine door closer',
    image: '/assets/images/models_images/Washing machine door closer.png',
    stlUrl: '/assets/models/Washing machine door closer.stl',
    description: 'A small mechanical part that helps a washing machine door close and stay in place.',
    technologies: ['Mechanical Design', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'mark4V210InchSmaCrsfMount',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Mark4 V2 10 inch sma crsf mount',
    image: '/assets/images/models_images/Mark4 V2 10 inch sma crsf mount.png',
    stlUrl: '/assets/models/Mark4 V2 10 inch sma crsf mount.stl',
    description: 'An antenna mount for a Mark4 V2 frame with support for SMA and CRSF hardware.',
    technologies: ['FPV Design', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: '10InchMark4V2AliexpressFpvGpsFrontMount',
    category: '3d',
    categoryLabel: '3D Model',
    title: '10 inch mark 4 v2 aliexpress fpv gps front mount',
    image: '/assets/images/models_images/10 inch mark 4 v2 aliexpress fpv gps front mount.png',
    stlUrl: '/assets/models/Gps mount fpv 10 inch v2 with Hole for xt60 connector.stl',
    description: 'A front GPS mount for a ten inch Mark4 V2 FPV frame.',
    technologies: ['FPV Design', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'kuugoM4FrontLicensePlateMount',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Kuugo M4 front license plate mount',
    image: '/assets/images/models_images/Kuugo M4 front license plate mount.png',
    stlUrl: ['/assets/models/KuugoM4_Front_PlateMount_Improved- Front part.stl', '/assets/models/KuugoM4_Front_PlateMount_Improved- Back part.stl'],
    description: 'A front license plate mount for a Kuugo M4 electric scooter.',
    technologies: ['Fusion 360', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'kuugoM4ElectricScooterInternalSteeringTube',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Kuugo m4 Electric scooter internal steering tube',
    image: '/assets/images/models_images/Kuugo m4 Electric scooter internal steering tube.png',
    stlUrl: '/assets/models/Kuugo m4 Electric scooter internal steering tube.stl',
    description: 'A replacement steering tube for the inside of a Kuugo M4 scooter.',
    technologies: ['Mechanical CAD', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'hsw500wDremelHolderV2',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'HSW 500w Dremel Holder v2',
    image: '/assets/images/models_images/HSW 500w Dremel Holder v2.png',
    stlUrl: '/assets/models/HSW 500w Dremel Holder v2.stl',
    description: 'A revised wall mount for a 500W rotary tool made for a Honeycomb Storage Wall.',
    technologies: ['Fusion 360', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'hsw500wDremelHolder',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'HSW 500w Dremel Holder',
    image: '/assets/images/models_images/HSW 500w Dremel Holder.png',
    stlUrl: '/assets/models/HSW 500w Dremel Holder.stl',
    description: 'A wall mount for a 500W rotary tool that fits the HSW system.',
    technologies: ['Fusion 360', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'hswHoneycombDt9205pMultimeterHolder',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'HSW Honeycomb dt9205p multimeter holder',
    image: '/assets/images/models_images/HSW Honeycomb dt9205p multimeter holder.png',
    stlUrl: '/assets/models/HSW Honeycomb dt9205p multimeter holder.stl',
    description: 'A holder for a DT9205P multimeter that fits the HSW system.',
    technologies: ['Fusion 360', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'hswHoneycombDrillBatteryHolder',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'HSW Honeycomb Drill battery holder',
    image: '/assets/images/models_images/HSW Honeycomb Drill battery holder.png',
    stlUrl: '/assets/models/HSW Honeycomb Drill battery holder.stl',
    description: 'A Honeycomb Storage Wall holder for a power drill battery.',
    technologies: ['CAD', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'antiMosquitoWindow',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Anti mosquito window',
    image: '/assets/images/models_images/Anti mosquito window.png',
    stlUrl: ['/assets/models/Window first half.stl', '/assets/models/Window second half.stl'],
    description: 'A window insert that keeps airflow while making it harder for mosquitoes to get inside.',
    technologies: ['CAD', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'deskLampThatSlidesUnderTheMonitorArm',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Desk lamp that slides under the monitor arm',
    image: '/assets/images/models_images/Desk lamp that slides under the monitor arm.png',
    description: 'A small desk lamp that slides under a monitor arm to save desk space.',
    technologies: ['Product Design', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'ventV5',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'vent v5',
    image: '/assets/images/models_images/vent v5.png',
    description: 'A vent model with adjustable dimensions for airflow and easier printing.',
    technologies: ['CAD', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'oralBToothbrushWallMount',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Oral B toothbrush wall mount',
    image: '/assets/images/models_images/Oral B toothbrush wall mount.png',
    stlUrl: '/assets/models/Oral B toothbrush wall mount.stl',
    description: 'A wall mount for Oral B toothbrushes that keeps them off the counter.',
    technologies: ['Fusion 360', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  },
  {
    id: 'tarkovUsecDogtag',
    category: '3d',
    categoryLabel: '3D Model',
    title: 'Tarkov Usec dogtag',
    image: '/assets/images/models_images/Tarkov Usec dogtag.png',
    stlUrl: '/assets/models/USEC DOGTAG v2.stl',
    description: 'A printed dogtag based on the USEC faction from Escape from Tarkov.',
    technologies: ['3D Modeling', '3D Printing'],
    githubUrl: 'https://www.printables.com/@Rozcy_765706/models'
  }
];

export default projects;